import React from 'react';
import { TenantFeatureKey } from './features';
import { useTenant } from './TenantProvider';

interface TenantFeatureProps {
  feature: TenantFeatureKey;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const TenantFeature = ({
  feature,
  children,
  fallback = null,
}: TenantFeatureProps) => {
  const { isFeatureEnabled } = useTenant();

  if (!isFeatureEnabled(feature)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default TenantFeature;
